import React from 'react';

const PasswordForget = () => {
  return null;
};

export default PasswordForget;